/* ==========================================================================
   Shoppable article — the undertone-test article's commerce layers.

   Nothing here is keyed to a sentence. The script finds the article's parts
   by shape and by the heading patterns the section passes in:

     - every H2 starts a section; the section is classified by its heading
     - the test is the <ol> whose items each carry a three-item <ul>
     - the scoring key is the "Mostly A's … likely cool" list under the
       results heading (so a re-lettered test still scores right)
     - the three undertone bullets become cards
     - the shade guide gets Violet's CTA after its "pick your depth" line

   State is the ONE value the landing page uses too: the matched Cream
   Concealer code, written by the Violet flyout through the hidden concealer
   sink (snippets/ssd-10a-state.liquid) and kept under the same localStorage
   key, so a match made on either page shows on both.
   ========================================================================== */
(function () {
  'use strict';

  var STORAGE_KEY = 'subtl:ssd10:match';
  var SITE_KEY = 'subtl:shade';

  function boot() {
    var root = document.querySelector('[data-sba]');
    if (!root || root.__sbaBound) return;
    root.__sbaBound = true;

    // ── Data (same blobs the landing page reads) ────────────────────────────
    function readJSON(sel, fallback) {
      var el = document.querySelector(sel); if (!el) return fallback;
      try { return JSON.parse(el.textContent); } catch (e) { return fallback; }
    }
    function readPairs(sel) {
      var el = document.querySelector(sel), out = {}; if (!el) return out;
      el.textContent.trim().split('|').forEach(function (pair) {
        var bits = pair.split(':'); if (bits.length >= 2 && bits[0]) out[bits[0].trim()] = bits.slice(1).join(':').trim();
      });
      return out;
    }
    var cfg = readJSON('[data-sba-config]', { strings: {}, match: {} });
    var S = cfg.strings || {};
    var variants = readJSON('[data-ssd10-variants]', []);
    var pans = readJSON('[data-ssd10-pans]', {});
    var bronzerMap = readPairs('[data-ssd10-bronzer-map]');
    var bbMap = readPairs('[data-ssd10-bb-map]');
    var handles = readJSON('[data-ssd10-handles]', {});
    var undertoneMap = {};
    (function () {
      var el = document.querySelector('[data-ssd10-undertone-map]'); if (!el) return;
      el.textContent.trim().split('|').forEach(function (row) {
        var f = row.split(':'); if (f.length >= 3) undertoneMap[f[0].trim().toUpperCase()] = { lipcheek: f[1].trim(), eyeshadow: f[2].trim() };
      });
    })();
    var shades = {}, shadeOrder = [];
    (function () {
      var el = document.querySelector('[data-ssd10-shade-table]'); if (!el) return;
      el.textContent.trim().split('|').forEach(function (row) {
        var f = row.split(':'); if (f.length >= 4) { shades[f[0]] = { hex: f[1], tone: f[2], tier: f[3] }; shadeOrder.push(f[0]); }
      });
    })();

    function fill(tpl, map) {
      return String(tpl || '').replace(/\{(\w+)\}/g, function (w, k) { return Object.prototype.hasOwnProperty.call(map, k) ? map[k] : w; });
    }
    function letterOf(code) { return String(code || '').trim().toUpperCase().slice(-1); }
    function pairingFor(code) {
      var u = undertoneMap[letterOf(code)] || undertoneMap.N || { lipcheek: '', eyeshadow: '' };
      return { concealer: code, bb: (state.matched === code && state.matchedBB) || bbMap[code] || '', bronzer: bronzerMap[code] || '', lipcheek: u.lipcheek, eyeshadow: u.eyeshadow };
    }
    function variantFor(code) {
      if (!code) return null;
      var bb = pairingFor(code).bb, exact = null, same = null;
      for (var i = 0; i < variants.length; i++) {
        var v = variants[i]; if (v.o2 !== code) continue;
        if (!same || (!same.a && v.a)) same = v;
        if (bb && v.o1 === bb) { exact = v; if (v.a) break; }
      }
      return exact || same;
    }

    // ── State ───────────────────────────────────────────────────────────────
    var state = { matched: null, matchedBB: null, matchedBy: null, matchId: null, undertone: null, answers: [] };
    try {
      var saved = JSON.parse(window.localStorage.getItem(STORAGE_KEY) || 'null');
      if (saved && saved.shade && shades[saved.shade]) { state.matched = saved.shade; state.matchedBB = saved.bb || null; }
      if (!state.matched) {
        var site = JSON.parse(window.localStorage.getItem(SITE_KEY) || 'null');
        if (site && site.concealer && shades[site.concealer]) { state.matched = site.concealer; state.matchedBy = site.by || null; state.matchId = site.match_id || null; }
      }
    } catch (e) { /* private mode: pre-match is the right default */ }
    function persist() {
      try {
        if (state.matched) window.localStorage.setItem(STORAGE_KEY, JSON.stringify({ shade: state.matched, bb: state.matchedBB }));
        else window.localStorage.removeItem(STORAGE_KEY);
      } catch (e) { /* ignore */ }
    }

    var content = root.querySelector('[data-sba-content]');
    var patterns = {};
    Object.keys(cfg.match || {}).forEach(function (k) { if (cfg.match[k]) patterns[k] = new RegExp(String(cfg.match[k]).replace(/[.*+?^${}()|[\]\\]/g, '\\$&'), 'i'); });
    var textOf = function (el) { return (el && el.textContent || '').replace(/\s+/g, ' ').trim(); };

    // ── 1. The duplicate title and the table of contents ───────────────────
    var titleText = textOf(root.querySelector('.sba__h1')).toLowerCase().replace(/[’']/g, '');
    Array.prototype.forEach.call(content.querySelectorAll('h2'), function (h) {
      if (textOf(h).toLowerCase().replace(/[’']/g, '') === titleText) h.remove();
    });
    var toc = null;
    Array.prototype.some.call(content.querySelectorAll('p'), function (p) {
      if (/table of contents/i.test(textOf(p)) && p.nextElementSibling && p.nextElementSibling.tagName === 'UL') {
        var list = p.nextElementSibling;
        toc = document.createElement('nav'); toc.className = 'sba__toc'; toc.setAttribute('aria-label', 'Table of contents');
        p.parentNode.insertBefore(toc, p); toc.appendChild(p); toc.appendChild(list);
        return true;
      }
      return false;
    });

    // ── 2. Sections at every H2, classified by heading ─────────────────────
    var sections = [];
    (function () {
      var nodes = Array.prototype.slice.call(content.childNodes);
      var current = null, order = 0;
      function open(h2) {
        var sec = document.createElement('section'); sec.className = 'sba__sec';
        var text = textOf(h2), key = 'other';
        // Most specific first: "Now Build Your Stak" must not read as a results heading.
        ['build', 'faq', 'match', 'test', 'myths', 'results', 'understand'].concat(Object.keys(patterns)).some(function (k) {
          if (patterns[k] && patterns[k].test(text)) { key = k; return true; } return false;
        });
        sec.setAttribute('data-sba-sec', key); sec.classList.add('sba__sec--' + key);
        if (h2.id) sec.id = h2.id + '-section';
        content.appendChild(sec); sections.push({ key: key, el: sec, h2: h2 }); return sec;
      }
      var lead = document.createElement('section'); lead.className = 'sba__sec sba__sec--first'; lead.setAttribute('data-sba-sec', 'top');
      content.appendChild(lead); current = lead; order++;
      nodes.forEach(function (n) {
        if (n.nodeType === 3 && !n.textContent.trim()) return;
        if (n.nodeType === 1 && n.tagName === 'H2') current = open(n);
        current.appendChild(n);
      });
    })();
    function sectionOf(key) { for (var i = 0; i < sections.length; i++) if (sections[i].key === key) return sections[i].el; return null; }
    Array.prototype.forEach.call(content.querySelectorAll('p'), function (p) { if (/^subtl protip/i.test(textOf(p))) p.classList.add('sba__protip'); });

    // ── 3. Undertone bullets become cards ──────────────────────────────────
    (function () {
      var sec = sectionOf('understand'); if (!sec) return;
      Array.prototype.some.call(sec.querySelectorAll('ul'), function (ul) {
        var items = ul.querySelectorAll(':scope > li');
        if (items.length !== 3) return false;
        var ok = Array.prototype.every.call(items, function (li) { var b = li.querySelector('b, strong'); return b && /undertone/i.test(textOf(b)); });
        if (!ok) return false;
        ul.classList.add('sba__cards');
        Array.prototype.forEach.call(items, function (li) {
          li.classList.add('sba__card');
          var b = li.querySelector('b, strong'); var title = textOf(b).split(/\s+/)[0];
          var t = document.createElement('span'); t.className = 'sba__card-title'; t.textContent = title;
          li.insertBefore(t, li.firstChild);
        });
        return true;
      });
    })();

    // ── 4. The test ────────────────────────────────────────────────────────
    var quiz = null;
    (function () {
      var sec = sectionOf('test'); if (!sec) return;
      var ol = null;
      Array.prototype.some.call(sec.querySelectorAll('ol'), function (o) {
        var lis = o.querySelectorAll(':scope > li');
        if (lis.length >= 3 && Array.prototype.every.call(lis, function (li) { return li.querySelector('ul') && li.querySelector('ul').querySelectorAll('li').length >= 2; })) { ol = o; return true; }
        return false;
      });
      if (!ol) return;
      var intro = ol.previousElementSibling;
      if (intro && intro.tagName === 'P' && /pen and paper/i.test(textOf(intro)) && S.quizIntro) intro.textContent = S.quizIntro;
      var questions = [];
      Array.prototype.forEach.call(ol.querySelectorAll(':scope > li'), function (li, qi) {
        var q = { text: '', opts: [] };
        var b = li.querySelector('b, strong'); q.text = b ? textOf(b) : textOf(li).split('\n')[0];
        Array.prototype.forEach.call(li.querySelector('ul').querySelectorAll('li'), function (opt) {
          var raw = textOf(opt); var m = raw.match(/^([a-z])\)\s*(.*)$/i);
          q.opts.push({ key: m ? m[1].toLowerCase() : String.fromCharCode(97 + q.opts.length), label: m ? m[2] : raw });
        });
        questions.push(q);
      });
      var box = document.createElement('div'); box.className = 'sba__quiz'; box.setAttribute('data-sba-quiz', '');
      questions.forEach(function (q, qi) {
        var qEl = document.createElement('div'); qEl.className = 'sba__q';
        var t = document.createElement('span'); t.className = 'sba__q-text'; t.textContent = (qi + 1) + '. ' + q.text; qEl.appendChild(t);
        var opts = document.createElement('div'); opts.className = 'sba__q-opts'; opts.setAttribute('role', 'group'); opts.setAttribute('aria-label', q.text);
        q.opts.forEach(function (o) {
          var wrap = document.createElement('div');
          var btn = document.createElement('button'); btn.type = 'button'; btn.className = 'sba__opt'; btn.setAttribute('aria-pressed', 'false');
          btn.dataset.q = qi; btn.dataset.key = o.key;
          var k = document.createElement('span'); k.className = 'sba__opt-key'; k.textContent = o.key + ')';
          btn.appendChild(k); btn.appendChild(document.createTextNode(o.label));
          wrap.appendChild(btn); opts.appendChild(wrap);
        });
        qEl.appendChild(opts); box.appendChild(qEl);
      });
      var progress = document.createElement('div'); progress.className = 'sba__progress'; progress.setAttribute('aria-live', 'polite');
      ol.parentNode.insertBefore(box, ol); ol.remove(); box.appendChild(progress);
      quiz = { box: box, questions: questions, progress: progress, keyTone: {} };
      state.answers = questions.map(function () { return null; });
      box.addEventListener('click', function (e) {
        var btn = e.target.closest('.sba__opt'); if (!btn) return;
        var qi = +btn.dataset.q; state.answers[qi] = btn.dataset.key;
        Array.prototype.forEach.call(btn.parentNode.parentNode.querySelectorAll('.sba__opt'), function (b) { b.setAttribute('aria-pressed', b === btn ? 'true' : 'false'); });
        paintQuiz(true);
      });
      // The band: the test and its results share the cream ground.
      var band = document.createElement('div'); band.className = 'sba__band sba__band--cream';
      sec.parentNode.insertBefore(band, sec); band.appendChild(sec); sec.classList.add('sba__col');
      var results = sectionOf('results');
      if (results) { sec.appendChild(results); results.classList.remove('sba__sec'); results.classList.add('sba__results'); results.style.display = 'flex'; results.style.flexDirection = 'column'; results.style.gap = '14px'; }
      // Scoring key from the results list: "Mostly A's … likely cool".
      var keyList = results && results.querySelector('ul');
      if (keyList) Array.prototype.forEach.call(keyList.querySelectorAll('li'), function (li) {
        var t = textOf(li); var m = t.match(/mostly\s+([a-z])/i); var tone = t.match(/\b(cool|warm|neutral)\b/i);
        if (m && tone) quiz.keyTone[m[1].toLowerCase()] = tone[1].toLowerCase();
      });
      if (!Object.keys(quiz.keyTone).length) quiz.keyTone = { a: 'cool', b: 'warm', c: 'neutral' };
      // The result card, after the results copy.
      var card = document.createElement('div'); card.className = 'sba__result'; card.setAttribute('data-violet-anchor', 'result-block'); card.hidden = true;
      card.innerHTML = '<span class="sba__eyebrow">' + esc(S.resultEyebrow || 'Your result') + '</span><span class="sba__result-title" data-sba-result-title></span><span class="sba__result-line" data-sba-result-line></span><div class="sba__chips" data-sba-result-chips></div>';
      var cta = document.createElement('button'); cta.type = 'button'; cta.className = 'sba__btn'; cta.setAttribute('data-sba-open', 'result-block');
      cta.innerHTML = markHTML('lilac') + '<span data-sba-result-cta></span>'; card.appendChild(cta);
      (results || sec).appendChild(card); quiz.card = card;
      paintQuiz(false);
    })();

    function esc(s) { var d = document.createElement('div'); d.textContent = s == null ? '' : s; return d.innerHTML; }
    function markHTML(tone) {
      // The marks are rendered once by Liquid on the sticky bar; clone them.
      var src = root.querySelector(tone === 'lilac' ? '[data-sba-ssd-cta] .vio-mark' : '[data-sba-sticky] .vio-mark--bubble');
      if (!src) { var t = root.querySelector('template[data-sba-ssd]'); src = t && t.content.querySelector('.vio-mark--bubble'); }
      return src ? src.outerHTML : '';
    }
    var TONE_LETTER = { cool: 'C', warm: 'W', neutral: 'N' };
    function quizResult() {
      if (!quiz || state.answers.some(function (a) { return a === null; })) return null;
      var n = {}; state.answers.forEach(function (k) { var t = quiz.keyTone[k] || 'neutral'; n[t] = (n[t] || 0) + 1; });
      var best = null, tie = false;
      Object.keys(n).forEach(function (t) { if (best === null || n[t] > n[best]) { best = t; tie = false; } else if (n[t] === n[best]) tie = true; });
      return tie ? 'neutral' : best;
    }
    function paintQuiz(scroll) {
      if (!quiz) return;
      var answered = state.answers.filter(function (a) { return a !== null; }).length, total = state.answers.length;
      var und = quizResult(); state.undertone = und;
      quiz.progress.textContent = und ? fill(S.progressDone || 'All {word} answered', { word: cfg.quizTotalWord || total, total: total }) : fill(S.progress || '{n} of {total} answered', { n: answered, total: total });
      if (!und) { quiz.card.hidden = true; return; }
      var letter = TONE_LETTER[und] || 'N';
      quiz.card.querySelector('[data-sba-result-title]').textContent = fill(S.resultTitle || 'You’re likely {undertone}.', { undertone: und });
      quiz.card.querySelector('[data-sba-result-line]').textContent = fill(S.resultLine || '', { undertone: und, letter: letter });
      quiz.card.querySelector('[data-sba-result-cta]').textContent = fill(S.resultCta || 'Let Violet pick your depth', { undertone: und });
      var chips = quiz.card.querySelector('[data-sba-result-chips]'); chips.innerHTML = '';
      shadeOrder.filter(function (c) { return letterOf(c) === letter; }).forEach(function (c) {
        var chip = document.createElement('span'); chip.className = 'sba__chip';
        var sw = document.createElement('span'); sw.className = 'sba__chip-swatch'; sw.style.background = shades[c].hex;
        chip.appendChild(sw); chip.appendChild(document.createTextNode(c)); chips.appendChild(chip);
      });
      var was = quiz.card.hidden; quiz.card.hidden = false;
      if (scroll && was) window.setTimeout(function () { var y = quiz.card.getBoundingClientRect().top + window.pageYOffset - 80; window.scrollTo({ top: y, behavior: 'smooth' }); }, 60);
    }

    // ── 5. Shade guide: Violet's CTA and the product link ──────────────────
    var rail = null;
    (function () {
      var sec = sectionOf('match'); if (!sec) return;
      var band = document.createElement('div'); band.className = 'sba__band sba__band--blush';
      sec.parentNode.insertBefore(band, sec); band.appendChild(sec); sec.classList.add('sba__col');
      // The article's own inline CTA block: keep its photo, retire its button.
      var oldLink = sec.querySelector('a[href*="starter-stak-deluxe"]');
      var oldBlock = oldLink && oldLink.closest('div');
      var photo = oldBlock && oldBlock.querySelector('img');
      rail = document.createElement('div'); rail.className = 'sba__rail-wrap'; rail.style.display = 'flex'; rail.style.flexDirection = 'column'; rail.style.gap = '12px';
      rail.innerHTML = '<span class="sba__rail-matched" data-sba-rail-matched hidden>' + heartHTML() + '<span data-sba-rail-matched-text></span></span>';
      var row = document.createElement('div'); row.className = 'sba__rail';
      var cta = document.createElement('button'); cta.type = 'button'; cta.className = 'sba__btn'; cta.setAttribute('data-sba-open', 'shade-rail-cta'); cta.setAttribute('data-violet-anchor', 'shade-rail-cta');
      cta.innerHTML = markHTML('lilac') + '<span data-sba-rail-cta></span>'; row.appendChild(cta);
      var link = document.createElement('a'); link.className = 'sba__link'; link.href = (oldLink && oldLink.getAttribute('href')) || cfg.ssdUrl; link.textContent = S.ssdLinkLabel || cfg.ssdLinkLabel || 'Shop the Starter Stak Deluxe →'; row.appendChild(link);
      rail.appendChild(row);
      // After the line that tells them to pick a depth; else before the photo.
      var anchor = null;
      Array.prototype.some.call(sec.querySelectorAll('p'), function (p) { if (/pick your depth/i.test(textOf(p))) { anchor = p; return true; } return false; });
      if (anchor) anchor.parentNode.insertBefore(rail, anchor.nextSibling); else if (oldBlock) oldBlock.parentNode.insertBefore(rail, oldBlock); else sec.appendChild(rail);
      if (oldBlock) { if (photo) { photo.style.cssText = ''; oldBlock.parentNode.insertBefore(photo, oldBlock); } oldBlock.classList.add('sba__gone'); }
    })();
    function heartHTML() { var src = root.querySelector('[data-sba-sticky] .vio-mark--heart'); return src ? src.outerHTML.replace(/width="\d+" height="\d+"/, 'width="16" height="16"') : ''; }

    // ── 6. The Starter Stak Deluxe module, after the shade guide ───────────
    var ssd = null;
    (function () {
      var tpl = root.querySelector('template[data-sba-ssd]'); if (!tpl) return;
      ssd = tpl.content.firstElementChild.cloneNode(true);
      var after = sectionOf('match'); after = after ? after.parentNode : sectionOf('results');
      if (after && after.parentNode) after.parentNode.insertBefore(ssd, after.nextSibling); else content.appendChild(ssd);
      if (toc) {
        var li = document.createElement('li'), a = document.createElement('a'); a.href = '#' + ssd.id; a.textContent = S.tocSsd || 'Shop the Starter Stak Deluxe';
        li.appendChild(a); var ul = toc.querySelector('ul'); var items = ul.querySelectorAll('li');
        // Before the FAQ entry when there is one, so the list keeps page order.
        var faqLi = Array.prototype.filter.call(items, function (x) { return /faq/i.test(textOf(x)); })[0];
        if (faqLi) ul.insertBefore(li, faqLi); else ul.appendChild(li);
      }
    })();

    // ── 7. FAQ and build sections ──────────────────────────────────────────
    (function () {
      var build = sectionOf('build'); if (!build) return;
      // The TikTok embed becomes a plain link on the line before it.
      var tt = build.querySelector('blockquote.tiktok-embed');
      if (tt) {
        var prev = tt.previousElementSibling, cite = tt.getAttribute('cite');
        if (prev && prev.tagName === 'P' && cite) { prev.appendChild(document.createTextNode(' ')); var a = document.createElement('a'); a.href = cite; a.target = '_blank'; a.rel = 'noopener'; a.textContent = S.tiktokLink || 'Watch it on TikTok.'; prev.appendChild(a); }
        tt.remove();
      }
      // Customer quotes group.
      var quotes = Array.prototype.filter.call(build.querySelectorAll(':scope > blockquote'), function (b) { return !b.classList.contains('tiktok-embed'); });
      if (quotes.length) { var g = document.createElement('div'); g.className = 'sba__quotes'; quotes[0].parentNode.insertBefore(g, quotes[0]); quotes.forEach(function (q) { g.appendChild(q); }); }
      // The closing flex box: image, heading, copy, two buttons.
      // The closing box is the flex <div> that holds an <h3>; take its outermost flex wrapper.
      var h3in = build.querySelector('div[style*="flex"] h3');
      var box = h3in && h3in.closest('div[style*="flex"]');
      while (box && box.parentNode && box.parentNode !== build && box.parentNode.tagName === 'DIV') box = box.parentNode;
      if (box && box.parentNode === build) {
        var img = box.querySelector('img'), h3 = box.querySelector('h3'), p = box.querySelector('p'), link = box.querySelector('a');
        var frag = document.createDocumentFragment();
        if (img) { img.style.cssText = ''; frag.appendChild(img); }
        if (h3) { h3.style.cssText = ''; frag.appendChild(h3); }
        if (p) { p.style.cssText = ''; frag.appendChild(p); }
        var row = document.createElement('div'); row.className = 'sba__build-cta';
        if (link) { link.style.cssText = ''; link.className = 'sba__btn sba__btn--full'; link.textContent = textOf(link).replace(/\s*→\s*$/, ''); row.appendChild(link); }
        if (cfg.buildUrl) { var b2 = document.createElement('a'); b2.className = 'sba__btn sba__btn--secondary sba__btn--full'; b2.href = cfg.buildUrl; b2.textContent = cfg.buildLabel || 'Build My Makeup Stak'; row.appendChild(b2); }
        frag.appendChild(row);
        box.parentNode.insertBefore(frag, box); box.remove();
      }
    })();

    // ── 8. Violet: open, match, add to bag ─────────────────────────────────
    function openViolet(source) {
      window.dispatchEvent(new CustomEvent('violet:open', { detail: { source: source, undertone: state.undertone, pick: null } }));
      var v = window.SubtlViolet; if (!v) return;
      if (/rematch/.test(source) && v.rematch) v.rematch(); else v.open();
    }
    root.addEventListener('click', function (e) {
      var open = e.target.closest('[data-sba-open]');
      if (open) { e.preventDefault(); openViolet(open.getAttribute('data-sba-open')); return; }
      var re = e.target.closest('[data-sba-rematch]');
      if (re) { e.preventDefault(); openViolet(re.getAttribute('data-violet-anchor') || 'rematch'); return; }
      var add = e.target.closest('[data-sba-add], [data-sba-ssd-cta]');
      if (add) { if (state.matched) addToBag(add); else openViolet(add.getAttribute('data-violet-anchor') || 'ssd-cta'); }
    });

    function setMatched(code, meta) {
      if (!shades[code]) return false;
      state.matched = code; state.matchedBB = null;
      state.matchedBy = (meta && meta.by) || 'violet'; state.matchId = (meta && meta.matchId) || null;
      persist(); paint();
      window.dispatchEvent(new CustomEvent('violet:matched', { detail: { code: code } }));
      return true;
    }
    // The hidden sink is the writer the flyout and the chat script both use.
    var sink = document.querySelector('[data-ssd10-sink="concealer"]');
    if (sink) sink.addEventListener('change', function () { if (sink.value && sink.value !== state.matched) setMatched(sink.value, { by: state.matchedBy || 'chat' }); });

    function addToBag(trigger) {
      var code = state.matched, v = variantFor(code); if (!v || !v.a) return;
      trigger.classList.add('is-loading');
      var routeRoot = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
      var item = { id: v.id, quantity: 1, properties: { _shade_match: code, _shade_matched_by: state.matchedBy || 'violet' } };
      if (state.matchId) item.properties._violet_match_id = state.matchId;
      var pr = pairingFor(code);
      if (pr.bb) item.properties._bb_powder = pr.bb; if (pr.bronzer) item.properties._powder_bronzer = pr.bronzer;
      if (pr.lipcheek) item.properties._lip_and_cheek = pr.lipcheek; if (pr.eyeshadow) item.properties._eyeshadow_duo = pr.eyeshadow;
      fetch(routeRoot + 'cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ items: [item] }) })
        .then(function (r) { return r.json().catch(function () { return null; }); })
        .then(function () {
          trigger.classList.remove('is-loading');
          var sc = window.Rebuy && window.Rebuy.SmartCart;
          if (sc && sc.status === 'ready' && typeof sc.show === 'function') sc.show();
          document.dispatchEvent(new CustomEvent('subtl:ssd10:added', { detail: { code: code } }));
          document.dispatchEvent(new CustomEvent('cart:item-added'));
        })
        .catch(function () { trigger.classList.remove('is-loading'); window.alert(S.addFailed || 'Sorry, that could not be added to your bag.'); });
    }

    // The bridge the Violet flyout talks to (same shape as the landing page).
    window.SubtlSSD10A = {
      shades: shades, handles: handles, price: cfg.price || '',
      pairingFor: pairingFor, variantFor: variantFor,
      panFor: function (role, shade) { return ((pans.variant || {})[role] || {})[shade] || ((pans.pan || {})[role] || {})[shade] || ''; },
      applyMatch: function (code, meta) { if (sink && shades[code]) { state.matchedBy = (meta && meta.by) || 'violet'; state.matchId = (meta && meta.matchId) || null; sink.value = code; sink.dispatchEvent(new Event('change', { bubbles: true })); return true; } return setMatched(code, meta); },
      suggest: function () {},
      addToBag: function () { var b = root.querySelector('[data-sba-ssd-cta]') || root.querySelector('[data-sba-add]'); if (b) addToBag(b); },
      openKustomer: function () { try { if (window.Kustomer && window.Kustomer.open) window.Kustomer.open(); } catch (e) { /* ignore */ } }
    };

    // ── 9. Paint every matched-state flip ──────────────────────────────────
    var ROLE_LABEL = { lipcheek: 'lipcheek', bronzer: 'bronzer', eyeshadow: 'eyeshadow', concealer: 'concealer', bb: 'bb' };
    function paint() {
      var m = state.matched, price = cfg.price || '';
      Array.prototype.forEach.call(root.querySelectorAll('[data-sba-pre]'), function (el) { el.hidden = !!m; });
      Array.prototype.forEach.call(root.querySelectorAll('[data-sba-bag]'), function (el) { el.hidden = !m; });
      var mine = root.querySelector('[data-sba-sticky-mine]'); if (mine) mine.textContent = m ? fill(S.stickyMatched || '{code} is yours.', { code: m }) : '';
      var bag = root.querySelector('[data-sba-sticky-bag]'); if (bag) bag.textContent = fill(S.stickyBag || 'Add to bag · {price}', { price: price });
      var railCta = root.querySelector('[data-sba-rail-cta]'); if (railCta) railCta.textContent = m ? fill(S.railCtaMatched || 'Ask Violet about {code}', { code: m }) : (S.railCta || 'Match with Violet');
      var railM = root.querySelector('[data-sba-rail-matched]'); if (railM) { railM.hidden = !m; var t = railM.querySelector('[data-sba-rail-matched-text]'); if (t) t.textContent = m ? fill(S.railMatchedLine || '', { code: m }) : ''; }
      if (ssd) {
        var pr = m ? pairingFor(m) : null;
        Array.prototype.forEach.call(ssd.querySelectorAll('[data-sba-row-shade]'), function (el) {
          var role = el.getAttribute('data-sba-row-shade'); var shade = pr ? (role === 'concealer' ? m : pr[ROLE_LABEL[role]] || '') : '';
          el.hidden = !shade; el.textContent = shade ? fill(S.ssdInShade || 'in {shade}', { shade: shade }) : '';
        });
        var label = ssd.querySelector('[data-sba-ssd-cta-label]'); if (label) label.textContent = m ? fill(S.ssdCtaMatched || 'Add to bag in {code}, {price}', { code: m, price: price }) : (S.ssdCta || 'Match with Violet to see your shade');
        var mark = ssd.querySelector('[data-sba-ssd-cta] .sba__btn-mark'); if (mark) mark.hidden = !!m;
        var rm = ssd.querySelector('[data-sba-rematch]'); if (rm) rm.hidden = !m;
        // The pod stack shows the pans for the matched shade; before a match,
        // a light neutral set. The handoff image stays as the fallback.
        var base = m || cfg.defaultShade || '004N';
        var pp = pairingFor(base);
        Array.prototype.forEach.call(ssd.querySelectorAll('[data-sba-pod]'), function (img) {
          var role = img.getAttribute('data-sba-pod');
          var shade = role === 'concealer' ? base : pp[role];
          var src = shade ? (((pans.pan || {})[role] || {})[shade] || '') : '';
          var next = src || img.getAttribute('data-fallback');
          if (next && img.getAttribute('src') !== next) img.setAttribute('src', next);
          if (shade) img.alt = img.alt.replace(/ in .*$/, '') + ' in ' + shade;
        });
      }
    }
    paint();
  }

  function safeBoot() { try { boot(); } catch (e) { window.__sbaError = String(e && e.stack || e); if (window.console) console.error('article-shoppable', e); } }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', safeBoot); else safeBoot();
})();
